import { render, staticRenderFns } from "./demos.vue?vue&type=template&id=aff2b076&"
import script from "./demos.vue?vue&type=script&lang=js&"
export * from "./demos.vue?vue&type=script&lang=js&"
import style0 from "./demos.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports